export class DocumentDownloadHelper {
    static downloadDocument(blob, fileName) {
        const url = window.URL.createObjectURL(blob);
        if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
        }
        else {
            this.downloadDocumentForNonIEBrowser(url, fileName);
        }
        window.URL.revokeObjectURL(url);
        return blob;
    }
    static downloadDocumentForNonIEBrowser(url, fileName) {
        let a = document.createElement('a');
        document.body.appendChild(a);
        a.style.display = 'none';
        a.href = url;
        a.download = fileName;
        a.click();
        a.remove();
    }
}
//# sourceMappingURL=DocumentDownloadHelper.js.map